module.exports = __webpack_public_path__ + "static/media/ico-windows.369ed4a0.svg";